import React from 'react';
export function Footer() {
  return <footer className="bg-black py-12 px-5 sm:px-6 border-t border-white/10 text-center" data-id="element-202">
      <div className="container mx-auto max-w-3xl" data-id="element-203">
        <h3 className="text-[#eab308] font-serif font-bold text-xl md:text-2xl mb-2 tracking-widest" data-id="element-204">
          🪷 ACADEMIA HOLÍSTICA ARGENTINA™
        </h3>
        <p className="text-gray-300 text-sm md:text-base mb-8" data-id="element-205">
          El sistema de formación en Reiki N°1 para Argentina. Porque tu camino
          espiritual no debería postergarse por falta de una formación a la
          altura.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-gray-400 text-sm mb-10" data-id="element-206">
          <span className="flex items-center gap-2" data-id="element-207">
            📧 academiaholisticaargentina@gmail.com
          </span>
          <span className="flex items-center gap-2" data-id="element-208">
            📲 Instagram: @academiaholisticaargentina
          </span>
          <span className="flex items-center gap-2" data-id="element-209">
            📘 Facebook: Academia Holística Argentina
          </span>
        </div>

        <div className="text-gray-500 text-xs space-y-4" data-id="element-210">
          <p data-id="element-211">
            © Academia Holística Argentina™ 2026 — Todos los derechos
            reservados.
          </p>
          <p data-id="element-212">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-white font-serif italic text-lg mt-6" data-id="element-213">
            🪷 "El momento que siempre esperaste ya llegó."
          </p>
        </div>
      </div>
    </footer>;
}